import ios from "../mds/ios.md"
import android from "../mds/android.md"
import iosBudget from "../mds/ios_onw.md"
import androidBudget from "../mds/android_onw.md"
import iosOverseas from "../mds/ios_overseas.md"
import androidOverseas from "../mds/android_overseas.md"
import mockOverseas from "../mds/mock_overseas.md"
import privacy from "../mds/privacy.md"
import compliance from "../mds/compliance.md"
import mock from "../mds/mock.md"
import minor from "../mds/minor.md"

// 数据封装
export function dataEncapsulation(data) {
    // 未成年人规则页：仅展示“未成年”文档
    if (window.location.pathname.indexOf("minor") !== -1) {
        return [{"value": "18", "key": "18", "label": "未成年人个人信息处理规则", "download": "1", "markdown": minor}]
    }

    let mdTypes = []
    let i = 0

    // 自有预算下载地址
    let iosDownloadPath = "https://static.wxcjgg.cn/upload/ios/own-budget/Example.zip"
    let androidDownloadPath = "https://static.wxcjgg.cn/upload/android/self/CJMobileAdDemo.zip"

    //海外预算下载地址
    let iosOverseasDownloadPath = "https://static.wxcjgg.cn/upload/ios/overseas-budget/Example.zip"
    let androidOverseasDownloadPath = "https://static.wxcjgg.cn/upload/android/overseas/CJMobileAdDemo.zip"

    // 自有预算
    let isOwnBudget = (window.location.pathname.indexOf("own-budget") !== -1)
    // 海外预算
    let isOverseas = (window.location.pathname.indexOf("overseas-budget") !== -1)

    data.filter((stand)=> {
        let name = ""
        let markdown = null
        name = stand.name
        if (stand.name.indexOf("Android") !== -1) {
            markdown = isOwnBudget ? androidBudget : (isOverseas ? androidOverseas : android)
            stand.download = isOwnBudget ? androidDownloadPath : (isOverseas ? androidOverseasDownloadPath : stand.download)
            name = "Android SDK"
        }
        if (stand.name.indexOf("iOS") !== -1 ) {
            markdown = isOwnBudget ? iosBudget : (isOverseas ? iosOverseas : ios)
            stand.download = isOwnBudget ? iosDownloadPath : (isOverseas ? iosOverseasDownloadPath : stand.download)
            name = "iOS SDK"
        }
        if (stand.name.indexOf("隐私") !== -1 ) {
            markdown = privacy
        }
        if (stand.name.indexOf("合规") !== -1) {
            markdown = compliance
            name = "SDK合规使用指南"
        }
        if (stand.name.indexOf("mock") !== -1 || stand.name.indexOf("测") !== -1 ) {
            markdown = isOverseas ? mockOverseas : mock
            name = "测试广告位"
        }
        let standValue = {"value": i.toString(), "key": i.toString(), "label": name, "download": stand.download, "markdown": markdown}
        if (isOwnBudget ||isOverseas) {
            if ((stand.name.indexOf("Android") !== -1 || stand.name.indexOf("iOS") !== -1 || stand.name.indexOf("mock") !== -1)) {
                mdTypes.push(standValue)
            }
        } else {
            mdTypes.push(standValue)
        }
        i ++
    })
    return mdTypes
}
